export const main = {
  localLink: {
    smooth: true,
    spy: true,
    offset: -70,
    duration: 1500,
    activeClass: 'active',
  },
}
